import callApiAxiosClient from '../../axios/axios_client';

function postReport(guid: string): Promise<string> {
  const token = JSON.parse(localStorage.getItem('user')!);
  const authorization = 'Bearer ' + token.token;
  return callApiAxiosClient<string>({
    method: 'post',
    url: 'media/report',
    headers: {
      'Content-Type': 'Application/json',
      Authorization: authorization,
    },
    params: {
      guid: guid,
    },
  });
}
export default postReport;
